import { getSubSteps } from '#models/general/steps';

import { getCaskInformationPageFields } from './caskFillingInformation';

export const CASKS_SUBSTEP_TARGET = 'AdelphiCaskFillingModal';

export const CASKS_SUBSTEPS_IDS = {
  CASK_FILLING_INFORMATION: 'caskFillingInformation'
};

const CASKS_NEXT_SUBSTEPS = {};

const CASKS_PREVIOUS_SUBSTEPS = {};

export const CASKS_SUBSTEPS = getSubSteps(
  CASKS_SUBSTEP_TARGET,
  CASKS_SUBSTEPS_IDS,
  CASKS_NEXT_SUBSTEPS,
  CASKS_PREVIOUS_SUBSTEPS
);

export const CASKS_COMPLETE_FIELDS = {
  [CASKS_SUBSTEPS_IDS.CASK_FILLING_INFORMATION]: getCaskInformationPageFields
};

export const CASKS_SUBSTEPS_ADDITION_PROPS = {
  [CASKS_SUBSTEPS_IDS.CASK_FILLING_INFORMATION]: {
    oneColumnForm: true
  }
};

export const ADELPHI_CASKS_SUBSTEPS_INFO = {
  target: CASKS_SUBSTEP_TARGET,
  substeps: CASKS_SUBSTEPS,
  fields: CASKS_COMPLETE_FIELDS,
  additionalProps: CASKS_SUBSTEPS_ADDITION_PROPS
};

export const CASKS_INFORMATION_FIELDS = {
  PERIOD_ID: 'periodId',
  FILL_ID: 'fillId',
  CASK_FILLING_FILE: 'caskFillingFile'
};
